import { render, staticRenderFns } from "./IoInformationCircleOutline.vue?vue&type=template&id=2bb9953a"
import script from "./IoInformationCircleOutline.vue?vue&type=script&lang=ts"
export * from "./IoInformationCircleOutline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports